














































import Vue from 'vue';

import { mapActions, mapGetters } from '@/state/modules/survey_builder';

export default Vue.extend({
  name: 'QuestionsPagination',
  computed: {
    ...mapGetters(['pages', 'currentPage', 'hasPreviousPage', 'hasNextPage']),
  },
  methods: {
    ...mapActions(['setPage', 'goToNextPage', 'goToPreviousPage', 'addPage']),
  },
});
